import React from 'react';
import Recorder from './Recorder';

/**
 * RecorderLauncher toont de recorderkaart (oats-design) inline op de
 * recordings-pagina. De kaart toont zelf de juiste staat: startknop (idle),
 * controlbar (tijdens opname) of upload-voortgang.
 */
const RecorderLauncher: React.FC = () => (
    <div className="mb-8" id="main-recorder-button">
        <Recorder variant="inline" />
    </div>
);

export default RecorderLauncher;
